import { HiChevronLeft } from "react-icons/hi2";

export const ArrowHead = ({ width, height, color, ...props }) => (
  <HiChevronLeft
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
